import BotClient1 from '../api/BotClient.js';

/**
 * Simple Deepgram Token Service
 * Handles fetching and caching of temporary Deepgram tokens
 */
class DeepgramTokenService {
  constructor() {
    this.botClient = new BotClient1();
    this.tokenCache = null;
    this.tokenExpiry = null;
  }

  /**
   * Get a valid Deepgram token (cached or fetch new one)
   */
  async getToken() {
    // Check if we have a valid cached token
    if (this.tokenCache && this.tokenExpiry && Date.now() < this.tokenExpiry) {
      console.log('[DeepgramToken] Using cached token : ',this.tokenCache);
      return this.tokenCache;
    }

    // Fetch new token
    console.log('[DeepgramToken] Fetching new token from server');
    return await this.fetchNewToken();
  }

  /**
   * Fetch a new token using BotClient
   */
  async fetchNewToken() {
    try {
      const tokenData = await this.botClient.getDeepgramToken();
      console.log("[DEEPGRAM] tokenData : ",tokenData)
      
      // Cache the token with expiry (subtract 5 minutes for safety margin)
      this.tokenCache = tokenData.token;
      this.tokenExpiry = Date.now() + (tokenData.expires_in - 300) * 1000;
      
      console.log('[DeepgramToken] New token cached, expires in:', tokenData.expires_in, 'seconds');
      return this.tokenCache;

    } catch (error) {
      console.error('[DeepgramToken] Error fetching token:', error);
      throw new Error('Failed to fetch Deepgram token: ' + error.message);
    }
  }

  /**
   * Clear cached token
   */
  clearToken() {
    this.tokenCache = null;
    this.tokenExpiry = null;
    console.log('[DeepgramToken] Token cache cleared');
  }
}

// Create singleton instance
const deepgramTokenService = new DeepgramTokenService();

export default deepgramTokenService;
